import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MatchDesk } from '../MatchDesk';
import { EGamePhase, } from '../../../types';
import { useAppSelector } from '../../../hooks';
import { selectMatchState } from '../../../store/match';
import background from '../../../../public/img/background.png';
const Container = styled.div `
  position: fixed;
  inset: 0;

  overflow: hidden;
  background-image: url(${background});
  background-position: center;
  background-size: cover;
`;
export function DeskPool({ onPlayerClickAction, gameButtonState, addOnComponent }) {
    const matchState = useAppSelector(selectMatchState);
    const [matchPlayers, setMatchPlayers] = useState([]);
    const [deskPool, setDeskPool] = useState(null);
    const [viewDesk, setViewDesk] = useState(1);
    const [currentPlayerId, setCurrentPlayerId] = useState(null);
    useEffect(() => {
        setMatchPlayers((matchState === null || matchState === void 0 ? void 0 : matchState.players) || []);
    }, [matchState]);
    const playerInDesk = (playerId, players) => !!players.find((p) => p.id === playerId);
    const findDeskByPlayer = (playerId) => {
        const res = deskPool === null || deskPool === void 0 ? void 0 : deskPool.pool.find((desk) => playerInDesk(playerId, desk.players));
        // console.log('DeskPool findDeskByPlayer', res)
        return res === null || res === void 0 ? void 0 : res.deskNumber;
    };
    useEffect(() => {
        if (!currentPlayerId)
            return;
        const res = findDeskByPlayer(currentPlayerId);
        setViewDesk(res || 1);
    }, [currentPlayerId]);
    return (_jsx(Container, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: _jsx(MatchDesk, { players: matchPlayers, onClickPlayerAction: onPlayerClickAction, gameButtonState: gameButtonState, setCurrentPlayerId: setCurrentPlayerId, addOnComponent: addOnComponent }) })));
}
